import React, { useMemo, useEffect, useState } from "react";
import BootstrapTable from "react-bootstrap-table-next";
import { useDispatch, useSelector, shallowEqual } from "react-redux";

// formating table
import * as columnFormatters from "./column-formatter";
import "react-bootstrap-table2-paginator/dist/react-bootstrap-table2-paginator.min.css";

// Metronic helper to done sorting-table ,select row etc.
import {
  sortCaret,
  getHandlerTableChange,
} from "../../../_metronic/_helpers";
import paginationFactory, { PaginationProvider } from "react-bootstrap-table2-paginator";
import { Pagination } from "../../../_metronic/_partials/controls";
// import * as uiHelpers from "../UserUIHelper";
import GlobalLoader from "../../../common/loaders/LoadingBox";
import { useWixPriceUIContext } from "../WixPriceUIContext";
import { fetchWixDataPricing } from "../../../actions/wix-pricing/wix";
import Fuse from "fuse.js";

export function WixPriceTable() {

  const [loader, setLoader] = useState(true);

  const { wixPricing } = useSelector(
    (state) => ({
      wixPricing:
        state.wixPricing && state.wixPricing.allWix && state.wixPricing.allWix.docs,
    }),
    shallowEqual
  );

  const { count } = useSelector(
    (state) => ({
      count:
        state.wixPricing && state.wixPricing.allWix && state.wixPricing.allWix.totalDocs,
    }),
    shallowEqual
  );


  const dispatch = useDispatch();

  const priceUIContext = useWixPriceUIContext();
  const priceUIProps = useMemo(() => {
    return {
      ids: priceUIContext.ids,
      setIds: priceUIContext.setIds,
      queryParams: priceUIContext.queryParams,
      setQueryParams: priceUIContext.setQueryParams,
      openEditPricePage: priceUIContext.openEditPricePage,
      openDeletePriceDialog: priceUIContext.openDeletePriceDialog,
    };
  }, [priceUIContext]);

  useEffect(() => {

    async function getWix() {
      setLoader(true);

      await dispatch(fetchWixDataPricing(priceUIProps.queryParams));

      setLoader(false);
    }

    getWix();
  }, [priceUIProps.queryParams, dispatch]);

  const [searchQuery, setSearchQuery] = useState('');

  // const fuse = new Fuse(wixPricing ? wixPricing : [],
  //   {
  //     keys: ["plan_name"]
  //   })

  // const results = fuse.search(searchQuery)

  let serchedResult = wixPricing;

  // const serchedResult = searchQuery ? results.map((result) => result.item) : wixPricing ? wixPricing : [];
  const sizePerPageList = [
    { text: "10", value: 10 },
    { text: "25", value: 25 },
    { text: "50", value: 50 },
    { text: "100", value: 100 },
  ];

  // Table pagination properties
  const paginationOptions = {
    custom: true,
    totalSize: searchQuery != undefined && searchQuery != "" ? serchedResult.length : count,
    sizePerPageList: sizePerPageList,
    sizePerPage: priceUIProps.queryParams.pageSize,
    page: priceUIProps.queryParams.pageNumber,
  };


  const handleOnChange = (e) => {
    const searchedVal = e.target.value;
    priceUIProps.setQueryParams({
      ...priceUIProps.queryParams,
      search: searchedVal
    });
    setSearchQuery(e.target.value);
  }

  const columns = [
    {
      dataField: "_id",
      text: "ID",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.RowIndex,
      style: { minWidth: "70px" },
      formatExtraData: {
        paginationOptions: paginationOptions,
        queryParams: priceUIProps.queryParams,
      }
    },
    {
      dataField: "plan_name",
      text: "Plan Name",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "plan_price",
      text: "Plan Price",
      sort: true,
      sortCaret: sortCaret,
      style: { minWidth: "150px" },
    },
    {
      dataField: "plan_inventory",
      text: "Quantity",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.InventoryColumnFormatter,
      style: { minWidth: "150px" },
    },  
    {
      dataField: "plan_type",
      text: "Plan Type",
      sort: true,
      sortCaret: sortCaret,
      formatter: columnFormatters.PlanTypeColumnFormatter,
      style: { minWidth: "150px" },
    }, 
    // {
    //   dataField: "date",
    //   text: " Created At",
    //   sort: true,
    //   sortCaret: sortCaret,
    //   formatter: columnFormatters.CreateDateColumnFormatter,
    //   style: {
    //     minWidth: "100px",
    //   },
    // },
    {
      dataField: "action",
      text: "Actions",
      formatter: columnFormatters.ActionsColumnFormatter,
      formatExtraData: {
        openEditPricePage: priceUIProps.openEditPricePage,
        openDeletePriceDialog: priceUIProps.openDeletePriceDialog,
      },
      classes: "text-right pr-0",
      headerClasses: "text-right pr-1",
      style: {
        minWidth: "100px",
      },
    },
  ];


  return (
    <>
      <PaginationProvider pagination={paginationFactory(paginationOptions)}>
        {({ paginationProps, paginationTableProps }) => {
          return (
            <Pagination
              paginationProps={paginationProps}
            >
              <div className="row">
                <div className="col-12">
                  <div className="form-group">
                    <input type="email" className="form-control" value={searchQuery} onChange={handleOnChange} placeholder="Search here"></input>
                  </div>
                </div>
              </div>
              <BootstrapTable
                wrapperClasses='table-responsive '
                classes='table table-head-custom table-vertical-center'
                bootstrap4
                bordered={false}
                remote
                keyField='_id'
                columns={columns}
                // data={products}
                data={serchedResult === null ? [] : serchedResult}
                onTableChange={getHandlerTableChange(
                  priceUIProps.setQueryParams
                )}
                {...paginationTableProps}
                noDataIndication={() => serchedResult === null ? '' : <div className="no-data-indication">No records found</div>}
              >
              </BootstrapTable>
              {loader && <GlobalLoader />}
            </Pagination>
          );
        }}
      </PaginationProvider>

    </>
  );
}
